module.exports = __webpack_public_path__ + "img/pre_post_house.5765aaa8.jpeg";